var OverlayMessageTrailerComponent = /** @class */ (function () {
    function OverlayMessageTrailerComponent() {
        this.playing = false;
        this.forwarding = false;
        this.rewinding = false;
        this.pause = false;
        this.showOverlayMessage = false;
        this.showOverlayProgress = false;
        this.showOverlayPlaybackTimeout = 1000;
        this.showOverlayPlaybackTimerTimeout = 6000;
        this.videoDuration = 0;
        this.videoCurrent = 0;
        this.playedPercentage = 0;
        this.curTimeText = '00:00';
        this.durTimeText = '00:00';
    }
    OverlayMessageTrailerComponent.prototype.isForwarding = function () {
        this.resetAllBooleans();
        this.forwarding = true;
        this.displayProgress();
    };
    OverlayMessageTrailerComponent.prototype.isRewinding = function () {
        this.resetAllBooleans();
        this.rewinding = true;
        this.displayProgress();
    };
    OverlayMessageTrailerComponent.prototype.hideVideoReadyToPlay = function () {
        this.showOverlayMessage = false;
        this.showOverlayProgress = false;
    };
    OverlayMessageTrailerComponent.prototype.showVideoReadyToPlay = function () {
        this.showOverlayMessage = true;
        this.showOverlayProgress = true;
    };
    OverlayMessageTrailerComponent.prototype.displayProgress = function () {
        var _this = this;
        this.clearTimers();
        this.showOverlayProgress = true;
        this.overlayPlayBackTimer = setTimeout(function () {
            _this.resetAllBooleans();
        }, this.showOverlayPlaybackTimeout);
        this.overlayPlayBackProgressTimer = setTimeout(function () {
            _this.showOverlayProgress = false;
        }, this.showOverlayPlaybackTimerTimeout);
    };
    OverlayMessageTrailerComponent.prototype.updateVideoDurationTime = function (duration) {
        this.videoDuration = duration;
        this.durTimeText = this.convertNumberToTimeNotation(duration);
    };
    OverlayMessageTrailerComponent.prototype.updateVideoCurrentTime = function (currentTime) {
        this.videoCurrent = currentTime;
        this.curTimeText = this.convertNumberToTimeNotation(currentTime);
        this.playedPercentage = (currentTime / this.videoDuration) * 100;
    };
    OverlayMessageTrailerComponent.prototype.convertNumberToTimeNotation = function (timeNumber) {
        var minutes = Math.floor(timeNumber / 60);
        var seconds = Math.floor(timeNumber % 60);
        var minutesText = minutes < 10 ? '0' + minutes : '' + minutes;
        var secondsText = seconds < 10 ? '0' + seconds : '' + seconds;
        return minutesText + ':' + secondsText;
    };
    OverlayMessageTrailerComponent.prototype.clearTimers = function () {
        if (this.overlayPlayBackTimer) {
            clearTimeout(this.overlayPlayBackTimer);
        }
        if (this.overlayPlayBackProgressTimer) {
            clearTimeout(this.overlayPlayBackProgressTimer);
        }
    };
    OverlayMessageTrailerComponent.prototype.resetAllBooleans = function () {
        this.rewinding = this.forwarding = this.playing = this.pause = false;
    };
    return OverlayMessageTrailerComponent;
}());
export { OverlayMessageTrailerComponent };
